// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomView_wrapper__vIDDA"};